import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { GetAuthenticatedSession } from '../helpers/get-authenticated-session';
import { getAuthTokenParsed } from '@sxm-de/dev-kits/web-sdk/utils';

interface AuthenticateWithIdentityGrantFnPayload {
    grant: string;
    username?: string;
}

export type AuthenticateWithIdentityGrantFn = (
    payload: AuthenticateWithIdentityGrantFnPayload,
) => Promise<void>;

export function initAuthenticateWithIdentityGrantFn({
    dependencies,
}: DomainInitPayload): AuthenticateWithIdentityGrantFn {
    const { clientSdkStorageProvider } = dependencies;
    return async (payload: AuthenticateWithIdentityGrantFnPayload) => {
        clientSdkStorageProvider &&
            setIdentityGrantAndUsername(payload, clientSdkStorageProvider);
        await GetAuthenticatedSession(dependencies);
    };
}

function setIdentityGrantAndUsername(
    { grant, username }: { grant: string; username?: string },
    storageProvider: {
        getItem: (name: string) => string;
        setItem: (name: string, value: string | object | number) => void;
    },
) {
    const authToken = JSON.parse(storageProvider.getItem('AUTH_TOKEN') || '');
    if (!authToken) {
        throw new Error('No auth token found');
    }
    const authTokenParsed = getAuthTokenParsed(authToken);
    const newAuthToken = {
        ...authTokenParsed,
        identityGrant: { grant: grant },
        ...(username ? { username } : {}),
    };
    storageProvider.setItem('AUTH_TOKEN', newAuthToken);
}
